var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"id":"videoPlayer","data-setup":"{ \"audioOnlyMode\": true, \"playbackRates\": [0.75, 1, 1.25, 1.5] }"}})}
var staticRenderFns = []

export { render, staticRenderFns }